import React from 'react'
import Main from '../components/SportsBoard/Main'

const SportsBoard = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default SportsBoard